import { Router } from '@angular/router';
import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';
import * as moment from 'moment-timezone';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { MatDialog } from '@angular/material';
import {SpeakerService} from '../../../globalservices/speaker/speaker.service';
import { EventSesrvice } from '../../../event.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
@Component({
selector: 'app-view-calender',
templateUrl: './view-calender.component.html',
styleUrls: ['./view-calender.component.css']
})
export class ViewCalenderComponent implements OnInit {
filterObj:any={};
sort:any={};
limit=1000;
start=0;
calendarOptions: Options;
displayEvent: any;
logger: any[] = [];
events: any[] = [];
downloadUrl:any;
// downloadUrl:SafeUrl;
currentMonth = moment();
eventInfo:any;
@Input('id') public id:string;
@Input('type') public type:string;
@Input('eventss') public eventss:any;

@ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
constructor(private sanitizer: DomSanitizer,public dialog:MatDialog,public router:Router,public speakerService:SpeakerService,
    public eventService: EventSesrvice) { }

ngOnInit() {
  let date=moment('2019-04-16T18:30:00.000Z').format('YYYY-MM-DD') 
   this.getEvents()

  let spanExpense = document.getElementsByClassName('expense-icon');
  

}
ngOnChanges(){
  console.log("this.id",this.type,this.id)
  this.getEvents();
}

    getEvents(){
    this.filterObj.userId=this.id;
    this.filterObj.type=this.type;
    this.speakerService.getUpcommingEvent(this.sort,this.filterObj,this.limit,this.start)
    .subscribe((result:any)=>{
      this.events=[];
    console.log("getEvents result",result.data.data);
    if(result.data.data.length>0){
      let apiResponse=result.data.data
  
      this.eventInfo=result.data.data[0];
      const blob = new Blob(["BEGIN:VCALENDAR VERSION:2.0 CALSCALE:GREGORIAN BEGIN:VEVENT SUMMARY:Access-A-Ride Pickup DTSTART;TZID=Eastern Standard Time:"+ +
      " DTEND;TZID=Eastern Standard Time:20130802T110400 LOCATION:"+result.data.data[0].location +
      " ACTION:DISPLAY END:VALARM END:VEVENT END:VCALENDAR"], { type: 'text/calendar' });
      this.downloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      this.eventInfo.downloadUrl=this.downloadUrl;
      this.eventInfo.downloadIcs=result.data.data[0].seriesName+".ics";
      for(var i in apiResponse){
      if(!apiResponse[i].date){
      continue;
      }
      let obj = {
      // "rendering": 'background', 
      "backgroundColor":"#eff3f9",
      "allDay":true,
      "start": moment(apiResponse[i].date).local(),
      "data" : apiResponse[i]
      }
      this.events.push(obj);
      }
      if(this.events.length>0){
      // this.ucCalendar.renderEvents(this.events)
      this.calendarOptions = {
      editable: false,
      eventLimit: false,
      selectable:false,
      timezone: 'UTC',
      defaultDate : this.currentMonth,
      header: {
      left: 'prev,next today',
      center: 'title',
      right: 'month,agendaWeek,agendaDay,listMonth'
      },
      events: this.events,
       eventRender: (v,el) => {console.log(v, el)}
      };
      }
    }else{
      this.calendarOptions = {
        editable: false,
        eventLimit: false,
        selectable:false,
        timezone: 'UTC',
        defaultDate : this.currentMonth,
        header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay,listMonth'
        },
        events: this.events,
        eventRender: (v,el) => {console.log(v, el)}
        };
    }
    
    console.log("this.events",this.events);
    })
    }
    nextButtonClick(){
    let date = this.ucCalendar.fullCalendar('getDate');
    date.add(1, 'months').startOf('month')
    this.currentMonth = moment(date).local();
    this.gotoDate(date);
    }

    prevButtonClick(){
    let date = this.ucCalendar.fullCalendar('getDate');
    date.subtract(1, 'months').startOf('month')
    this.currentMonth = moment(date).local();;
    this.gotoDate(date);
    }
    gotoDate(date) {
    console.log("Here @ date ", date)
    try{
    this.ucCalendar.fullCalendar('gotoDate', date)
    }catch(e){
    console.log(e)
    }
    }
    loadevents(model: any) {
    this.displayEvent = model;
    }

    eventClick(model: any) {
    model = {
    event: {
    id: model.event.id,
    start: model.event.start,
    end: model.event.end,
    title: model.event.title,
    allDay: model.event.allDay
    // other params
    },
    duration: {}
    }
    this.displayEvent = model;
    }
    updateEvent(model: any) {
    model = {
    event: {
    id: model.event.id,
    start: model.event.start,
    end: model.event.end,
    title: model.event.title
    // other params
    },
    duration: {
    _data: model.duration._data
    }
    }
    this.displayEvent = model;
    }
    windowResize(model: any) {
    console.log('The calendar has adjusted to a window resize');
    }
    viewRender(model: any) {
    console.log('viewRender');
    }
    // eventRender(model: any) {
    // this.logger.push(model);
    // }

    tConvert (time) {
      // Check correct time format and split into components
      time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    
      if (time.length > 1) { // If time format correct
        time = time.slice (1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join (''); // return adjusted time or original string
    }
    
  eventRender(e){
    console.log("e123",e.event.data);
    let stateName; 
    let timeZone;
    if(e.event.data!=undefined){
      if(e.event.data.meeting_type_id==2){
        e.event.data.location='',
        e.event.data.state_code='',
        stateName=e.event.data.city=''
      }else{
        stateName = e.event.data.city ? ', ' + e.event.data.city + ', ': '';
      }
      const blob = new Blob(["BEGIN:VCALENDAR VERSION:2.0 CALSCALE:GREGORIAN BEGIN:VEVENT SUMMARY:Access-A-Ride Pickup DTSTART;TZID=Eastern Standard Time:"+e.event.data.date+
      " DTEND;TZID=Eastern Standard Time:20130802T110400 LOCATION:"+e.event.data.location +
      " DESCRIPTION: "+ e.event.data.seriesName+
      " STATUS:"+ e.event.data.status+
      " SEQUENCE:3 BEGIN:VALARM TRIGGER:-PT10M DESCRIPTION:"+e.event.data.seriesName+
      " ACTION:DISPLAY END:VALARM END:VEVENT BEGIN:VEVENT SUMMARY:Access-A-Ride Pickup DTSTART;TZID=Eastern Standard Time:"+ e.event.data.date+
      " DTEND;TZID=Eastern Standard Time:20130802T203000 LOCATION:"+e.event.data.location+
      " DESCRIPTION: "+ e.event.data.seriesName+
      " STATUS:"+ e.event.data.status+
      " SEQUENCE:3 BEGIN:VALARM TRIGGER:-PT10M DESCRIPTION:"+ e.event.data.seriesName+
      " ACTION:DISPLAY END:VALARM END:VEVENT END:VCALENDAR"], { type: 'text/calendar' });
      this.downloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      e.event.data.downloadUrl=this.downloadUrl;
      e.event.data.downloadIcs=e.event.data.seriesName+".ics";
      let eventStart;
      let stateCode ;
      let eventEnd;
      if(e.event.data.startTime==null && e.event.data.startTime==undefined){
      eventStart = '';
      }else{

        // let date1 =moment(e.event.data.startTime, ["h:mm"])

        // date1.tz('Asia/Colombo').format("h:mm A");
        
        // let day1 = moment.unix(date1);

        // e.event.data.startTime = day1.format('h:mm A');

      // e.event.data.startTime=moment(e.event.data.startTime, ["h:mm"]).format("h:mm A")
      e.event.data.startTime = this.tConvert(e.event.data.startTime);

      eventStart = e.event.data.startTime +' -';

      }if(e.event.data.timeZone==null && e.event.data.timeZone==undefined){
        timeZone = '';
      }else{
      timeZone = e.event.data.timeZone ? e.event.data.timeZone: '';
      }
      if(e.event.data.state_code==null && e.event.data.state_code==undefined){
      stateCode = '';
      }else{
      stateCode = e.event.data.state_code ? e.event.data.state_code: '' ;
      }
      if(e.event.data.endTime==null && e.event.data.endTime==undefined){
      eventEnd = '';
      }else{

        // let date2 =moment(e.event.data.endTime, ["h:mm"]);

        // date2.tz('Asia/Colombo').format("h:mm A");
        
        // let day2 = moment.unix(date2);
        // console.log(">>>>>>event ed time",e.event.data.endTime);
        // console.log(">>>>>day2",day2);

        // e.event.data.endTime = day2.format('h:mm A');       

      // e.event.data.endTime=moment(e.event.data.endTime, ["h:mm"]).format("h:mm A");
      e.event.data.endTime = this.tConvert(e.event.data.endTime);

      if(e.event.data.meeting_type_id!=2){  
      eventEnd = e.event.data.endTime + ', ';
      }else{
      eventEnd = e.event.data.endTime + ', ';
      }
  }
  
  console.log(e.event.data.city);
     
      let html = `<div style="font-size: 11px;color: black;padding: 5px;">
      `+eventStart +`  `+ eventEnd + timeZone + ``+ stateName +` `+ stateCode +`
      </div>
      <div style="font-size: 11px;color: #3457bb;padding: 5px;">
      <a data-toggle="tooltip" title="event details!" href=/eventdetails/`+e.event.data.eventId+`>`+e.event.data.seriesName+`</a>
      </div>
      <span  routerLink="/calendar/event/1"> <a data-toggle="tooltip" title="map" href='https://www.google.com/maps?q=/`+e.event.data.city + ',' + e.event.data.state_code + ',' + e.event.data.location + ` ' target="_blank" class="externalLink"><img src="assets/icons/map.svg" class="icon-panel-align"></a></span>
      <span><a data-toggle="tooltip" title="event" href=/eventdetails/`+e.event.data.eventId+`><img src="assets/icons/details.svg" style="height:26px;width:23px" class="icon-panel-align"></a></span>
      <span style="height:26px;width:23px"><a data-toggle="tooltip" title="expenses" href=/expenses/`+e.event.data.eventId+` ><img style="height:26px;width:23px" src="assets/icons/check-mark.svg"></span>
      </div>
      <div class="icon-panel text-right" style="margin-bottom:5px;">
        </div>  `;
        
        
        let html1 = `<div style="font-size: 11px;color: black;padding: 5px;">
        `+eventStart +`  `+ eventEnd + timeZone + ``+ stateName +` `+ stateCode +`
        </div>
        <div style="font-size: 11px;color: #3457bb;padding: 5px;">
        <a data-toggle="tooltip" title="event details!" href=/eventdetails/`+e.event.data.eventId+`>`+e.event.data.seriesName+`</a>
        </div><span><a data-toggle="tooltip" title="event" href=/eventdetails/`+e.event.data.eventId+`><img src="assets/icons/details.svg" style="height:26px;width:23px" class="icon-panel-align"></a></span>
        <span style="height:26px;width:23px"><a data-toggle="tooltip" title="expenses" href=/expenses/`+e.event.data.eventId+` ><img style="height:26px;width:23px" src="assets/icons/check-mark.svg"></span>
        </div>
        <div class="icon-panel text-right" style="margin-bottom:5px;">
          </div>  `;

      if(e.event.data.meeting_type_id !== 2)
      e.element.html(html)
      else
      e.element.html(html1)
    }
 
   
  
    // <span><a ><img src="assets/icons/add.svg" class="icon-panel-align-add"></a></span>
    // <span ><a href=/eventdetails/"`+e.event.data.eventId+`"><img src="assets/icons/map.svg" class="icon-panel-align"></a></span>
    // <span><a href="https://www.google.com/maps?q=new+york&rlz=1C1CHZL_enIN796IN796&um=1&ie=UTF-8&sa=X&ved=0ahUKEwjN8-Ds2bHhAhVM73MBHYVBAV0Q_AUIDigB" target="_blank"><img src="assets/icons/details.svg" style="height:26px;width:23px" class="icon-panel-align"></a></span>
    // <span style="height:26px;width:23px"><img style="height:26px;width:23px" src="assets/icons/check-mark.svg"></span>
    // <span><a href=`+e.event.data.downloadUrl+` download=`+e.event.data.downloadIcs+`><img  src="assets/icons/add.svg" class="icon-panel-align-add"></a></span>
  }
  onSend(){
    console.log("this is cool");
  }
    initialized() {
    console.log('Initialized compleate');
    }

}
